import { createStore } from 'vuex';

import { moduleLogin } from '@/store/modules/login';
import { moduleDashboard } from '@/store/modules/dashboard';
import { moduleFastPayment } from '@/store/modules/dashboard.fastPayment';
import { modulePayout } from '@/store/modules/dashboard.payout';
import { moduleAccounts } from '@/store/modules/dashboard.accounts';
import { moduleMyFx } from '@/store/modules/myFx';
import { moduleDictionaries } from '@/store/modules/dictionaries';
import { moduleNewAccount } from '@/store/modules/new-account';
import { moduleNewsList } from '@/store/modules/newsList';
import { moduleMifid } from '@/store/modules/mifid';
import { modulePit } from '@/store/modules/pit';
import { moduleTrainingList } from '@/store/modules/trainingList';
import { moduleErrors } from '@/store/modules/errors';
import { moduleRwd } from '@/store/modules/rwd';
import { moduleMenu } from '@/store/modules/menu';
import { moduleLoader } from '@/store/modules/loader';
import { eLearning } from '@/store/modules/e-learning';
import { owk } from '@/store/modules/owk';
import { settings } from '@/store/modules/settings';
import { user } from '@/store/modules/user';

export default createStore({
	modules: {
		moduleLogin,
		moduleDashboard,
		moduleFastPayment,
		modulePayout,
		moduleAccounts,
		moduleMyFx,
		moduleDictionaries,
		moduleNewAccount,
		moduleNewsList,
		moduleMifid,
		modulePit,
		moduleTrainingList,
		moduleErrors,
		moduleRwd,
		moduleMenu,
		moduleLoader,
		eLearning,
		owk,
		settings,
		user,
	},
});
